import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"
import type { UITypes } from "types"

import { useLazyGetContractorMessagesBatchQuery, useLazyGetMessageReportQuery } from "store/api/contractorsApi"

import { convertMessageReportToTableRows } from "utils/convertData"
import getErrorMessage from "utils/getErrorMessage"
import useUrlQueryParams from "hooks/useUrlQueryParams"
import { ContentWrapper } from "components/common/ContentWrapper"
import { Pagination } from "components/common/Pagination"
import TableWrapper from "components/table/TableWrapper"

import HeaderTiles from "./HeaderTiles"
import { messageReportHeaderCells } from "./MessageReportHeaderCells"

import styles from "./index.module.scss"

export const MessageReport = () => {
  const [triggerGetMessageReport, { isFetching, data }] = useLazyGetMessageReportQuery()
  const [triggerGetMessageBatch, { data: messageBatch }] = useLazyGetContractorMessagesBatchQuery()
  const { urlQueryParams } = useUrlQueryParams()
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")
  const [isFirstRender, setFirstRender] = useState(true)

  const messageBatchData = messageBatch?.data?.[0] || undefined

  const sendRequest = async (params: UITypes.Params) => {
    if (!id) return

    try {
      const res = await triggerGetMessageReport({ id, params })
      const error = getErrorMessage(res?.error)

      if (error) {
        toast.error(error)
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (isFirstRender) {
      setFirstRender(false)
      return
    }
    sendRequest(urlQueryParams)
  }, [urlQueryParams, isFirstRender])

  useEffect(() => {
    if (id) {
      triggerGetMessageBatch({ id })
    }
  }, [data?.data[0]?.message_template_id])

  return (
    <>
      <ContentWrapper
        title={messageBatchData?.title}
        breadcrumbs={[
          {
            label: "Message center",
            link: "/messages2/center",
          },
          {
            label: "Message history",
            link: "/messages2/history",
          },
          {
            label: messageBatchData?.title ? messageBatchData?.title : "",
          },
        ]}
      >
        <nav className={styles.tableNavWrapper}>
          <HeaderTiles messageBatchData={messageBatchData} />
          <div className={styles.tableNavButtonsWrapper}>
            {/* <ButtonNew className={styles.tableNavItem} disabled>Export</ButtonNew> */}
          </div>
        </nav>
        <TableWrapper
          headerCells={messageReportHeaderCells}
          isLoading={isFetching}
          data={convertMessageReportToTableRows(data?.data)}
        />
        <Pagination meta={data?.meta} />
      </ContentWrapper>
    </>
  )
}
